import { Link } from "react-router-dom"; // ✅ ADD THIS
import AOS from 'aos';
import 'aos/dist/aos.css';
import Newsletter from "./Newsletters";
// ..
AOS.init();
export default function Footer() {
    return (
        <>

            <footer
                data-aos-duration="1000"
                className="relative bg-black pt-2 text-slate-700 sm:px-8 px-6 lg:px-14 rounded-t-2xl pb-6 overflow-hidden">
                {/* Background Image */}
                <div className="absolute inset-0  pointer-events-none">
                    <img
                        src="assets/images/footer-bg.png"
                        alt="bg"
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="relative z-10">
                    <Newsletter/>
                    <div data-aos="fade-up" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">

                        {/* Services */}
                        <div>
                            <h3 className="text-slate-100 text-lg mb-4 font-semibold ">Services</h3>
                            <ul className="space-y-2 flex text-slate-100 flex-col">
                                <Link to="https://pickupxpress.com/services/express-shipment" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Express Shipment</Link>
                                <Link to="https://pickupxpress.com/services/surface-shipment" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Surface Shipment</Link>
                                <Link to="https://pickupxpress.com/services/full-truck-load" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Full Truck Load</Link>
                                <Link to="https://pickupxpress.com/services/train-cargo" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Train Cargo</Link>
                                <Link to="https://pickupxpress.com/services/import-export" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Import Export</Link>
                                <Link to="https://pickupxpress.com/services/ecommerce-shipping" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Ecommerce Shippings</Link>
                            </ul>
                        </div>

                        {/* Company */}
                        <div>
                            <h3 className="text-slate-100 text-lg mb-4 font-semibold ">Company</h3>
                            <ul className="space-y-2 text-slate-100 flex flex-col">
                                <Link to="https://pickupxpress.com/about-us" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">About Us</Link>
                                <Link to="https://pickupxpress.com/careers" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Careers
                                </Link>
                                <Link to="https://pickupxpress.com/contact" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Contact Us</Link>
                                <Link to="https://pickupxpress.com/privacy-policy" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Privacy Policy</Link>
                                <Link to="https://pickupxpress.com/terms-conditions" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Terms & Conditions</Link>
                                                                <Link to="https://pickupxpress.com/faqs" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">FAQs</Link>

                            </ul>
                        </div>

                        {/* Legal */}
                        <div>
                            <h3 className="text-slate-100 text-lg mb-4 font-semibold ">Legal</h3>
                            <ul className="space-y-2 text-slate-100 flex flex-col">
                                <Link to="https://pickupxpress.com/accessibility" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Accessibility</Link>
                                <Link to="https://pickupxpress.com/refund-policy" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Refund Policy</Link>
                                <Link to="https://pickupxpress.com/cancellation-policy" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Cancellation Policy</Link>
                                <Link to="https://pickupxpress.com/csr" className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Corporate Social Responsibility</Link>
                            </ul>
                        </div>

                        {/* Downloads */}
                        <div>
                            <h3 className="text-slate-100 text-lg  font-semibold">Address</h3>
                            <ul className="space-y-2 text-slate-100">
                                <li className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">C-702, Ithum Tower
                                </li>
                                <li className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Block C, Industrial Area, Sector 62

                                </li>
                                <li className="hover:text-sky-400 hover:translate-x-1 transition-all cursor-pointer">Noida, Uttar Pradesh-201309

                                </li>
                            </ul>
                        </div>

                    </div>

                    <div className="mt-3 border-t border-slate-200/70 pt-6 flex flex-col md:flex-row flex-wrap items-center justify-between gap-4 text-sm text-slate-500 ">

                        {/* Left - Copyright */}
                        <p className="text-slate-100">© 2024. Olbuiz Logistics Pvt. Ltd. All rights reserved.</p>

                        {/* Center - Social Icons */}
                        <div className="flex gap-5 text-lg">
                            <a
                                href="https://www.facebook.com/pxpickupxpress?_rdr"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-facebook-f text-white hover:text-blue-400 cursor-pointer"></i>
                            </a>
                            <a
                                href="https://www.instagram.com/pickupxpress/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-instagram text-white hover:text-pink-400 cursor-pointer"></i>
                            </a>
                            {/* <i className="fab text-white fa-twitter hover:text-blue-400 cursor-pointer"></i> */}
                            <a href="https://api.whatsapp.com/send/?phone=918707000087&text=Thankyou+For+connecting+with+us%21&type=phone_number&app_absent=0"
                                target="_blank"
                                rel="noopener noreferrer">
                                <i className="fab text-white fa-whatsapp hover:text-blue-400 cursor-pointer"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/pickupxpress/" target="_blank" rel="noopener noreferrer">
                                <i className="fab text-white fa-linkedin-in hover:text-blue-400 cursor-pointer"></i>
                            </a>
                        </div>

                        {/* Right - Links */}
                        <div className="flex text-slate-100 gap-6">
                            <Link to="https://pickupxpress.com/terms-conditions" className="hover:text-blue-400 cursor-pointer">Terms & Conditions</Link>
                            <Link to="https://pickupxpress.com/privacy-policy" className="hover:text-blue-400 cursor-pointer">Privacy Policy</Link>
                            <Link to="https://pickupxpress.com/cookies" className="hover:text-blue-400 cursor-pointer">Cookies</Link>
                        </div>

                    </div>
                </div>

            </footer>
        </>
    );
}